var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMessageIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 18 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M.72 10.639V3.128A2.5 2.5 0 0 1 3.21.625h11.62c1.38 0 2.49 1.121 2.49 2.503v7.511a2.494 2.494 0 0 1-2.49 2.504h-3.52l-2.17 1.902c-1.34 1.181-3.44.223-3.44-1.57v-.332H3.21a2.5 2.5 0 0 1-2.49-2.504Zm6.44 1.712a1.658 1.658 0 0 0-1.46-.877H3.21a.832.832 0 0 1-.83-.835V3.128c0-.46.37-.834.83-.834h11.62c.46 0 .83.374.83.834v7.511c0 .461-.37.835-.83.835h-3.52c-.41 0-.79.147-1.1.413l-2.16 1.902a.416.416 0 0 1-.69-.314v-.485a1.805 1.805 0 0 0-.18-.614c-.01-.008-.01-.016-.02-.025Z",
  fill: "currentColor"
})));
export { SvgMessageIcon as ReactComponent };
export default __webpack_public_path__ + "images/message-icon.svg";